import { JsonObject, JsonProperty } from 'json2typescript';

export enum PublicationSelectionStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  DRAFT = 'DRAFT',
  READY = 'READY',
}

@JsonObject('PublicationSelection')
export class PublicationSelection {
  @JsonProperty('id', Number) id: number = undefined;
  @JsonProperty('name', String) name: string = undefined;
  @JsonProperty('supplierId', Number) supplierId: number = undefined;
  @JsonProperty('storeId', Number, true) storeId?: number = undefined;
  @JsonProperty('storeCode', String, true) storeCode?: string = undefined;
  @JsonProperty('masterId', Number, true) masterId?: number = undefined;
  @JsonProperty('status', String) status: PublicationSelectionStatus = undefined;
  @JsonProperty('barcodeCount', Number, true) barcodeCount = 0;

  get description(): string {
    const statusSuffix = this.status ? ` [${this.status}]` : '';
    return `${this.name}${statusSuffix}`;
  }
}
